export default __webpack_public_path__ + "static/media/V344_V346MANC3.c1869ee2.pdf";